import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import appStateReducer from './appStateSlice';
import appDataReducer from './appDataSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  app: appStateReducer,
  appData: appDataReducer,
});

export default rootReducer;